import App from '../App'
import TabPage from '../contenter/TabPage'
import MyPage from '../contenter/My/index'
import HelpCenterPage from '../contenter/Helpcenter/helpCenter/helpCenter.js'
import ServiceRulePage from '../contenter/Helpcenter/serviceRule/serviceRule.js'
import FeedBackPage from '../contenter/Helpcenter/feedBack/feedBack.js'
import RouteOrderListPage from '../contenter/RouteOrderList/routeOrderList.js'
import RouteOrderPage from '../contenter/RouteOrder/routeOrder.js'
import CancelOrderPage from '../contenter/CancelOrder/cancelOrder.js'
import CostDetailPage from '../contenter/CostDetail/costDetail.js'
import Store from '../contenter/Store/index'
import OrderPage from '../contenter/Order/OrderPage'
import LoginPage from '../contenter/Login/LoginPage'
import City from '../contenter/city/City.js';
import PaymentPage from '../contenter/Payment/PaymentPage'
import CouponList from '../contenter/coupon/couponList.js';
import CouponInstructions from '../contenter/coupon/couponInstructions.js';
import Stores from '../contenter/Stores/stores';
import StoreDetail from '../contenter/StoreDetail/storeDetail';
import ShopChange from '../contenter/ShopChange/shopChange';
import CarList from '../contenter/carList/index';
import PaySuccess from '../contenter/Order/PaySuccess'
import Webview from '../contenter/Webview/index'
import BindCard from '../contenter/BindCard/index';
import AddCard from '../contenter/AddCard/index';
import OpenCard from '../contenter/OpenCard/index';
import BankFrame from '../contenter/BankFrame/index';
import CardList from '../contenter/CardList/index';
import Index from '../contenter/index/index.js';
const routerConfig = [
  {
    path: '/index',
    exact:true,
    component: Index
  },
  {
    path: '/',
    exact:true,
    component: Index
  },
  // {
  //   path: '/city',
  //   component: City
  // },
  // {
  //   path: '/store',
  //   component: Store
  // },
  // {
  //   path: '/stores',
  //   component: Stores
  // },
  // {
  //   path: '/shopChange',
  //   component: ShopChange
  // },
  // {
  //   path: '/tabpage',
  //   component: TabPage
  // },
  // {
  //   path: '/order',
  //   component: OrderPage
  // },
  // {
  //   path: '/couponList',
  //   component: CouponList
  // },
  // {
  //   path: '/couponInstructions',
  //   component: CouponInstructions
  // },
  // {
  //   path: '/login',
  //   component: LoginPage
  // },
  // {
  //   path: '/my',
  //   component: MyPage
  // },
  // {
  //   path: '/routeOrderList',
  //   component: RouteOrderListPage
  // },
  // {
  //   path: '/routeOrder',
  //   component: RouteOrderPage
  // },
  // {
  //   path: '/cancelOrder',
  //   component: CancelOrderPage
  // },
  // {
  //   path: '/costDetail',
  //   component: CostDetailPage
  // },
  // {
  //   path: '/helpCenter',
  //   component: HelpCenterPage
  // },
  // {
  //   path: '/serviceRule',
  //   component: ServiceRulePage
  // },
  // {
  //   path: '/feedBack',
  //   component: FeedBackPage
  // },
  // {
  //   path: '/payment',
  //   component: PaymentPage
  // },
  // {
  //   path: '/carList',
  //   component: CarList
  // },
  // {
  //   path: '/webview',
  //   component: Webview
  // },
  // {
  //   path: '/storeDetail',
  //   component: StoreDetail
  // },
  // {
  //   path: '/paysuccess',
  //   component: PaySuccess
  // },
  // {
  //   path: '/bindCard',
  //   component: BindCard
  // },
  // {
  //   path: '/addCard',
  //   component: AddCard
  // },
  // {
  //   path: '/openCard',
  //   component: OpenCard
  // },
  // {
  //   path: '/frame',
  //   component: BankFrame
  // },
  // {
  //   path: '/cardList',
  //   component: CardList
  // }
];

export default routerConfig;
